import { token } from '@atlaskit/tokens';

// Matches the color palette mission control uses for their charts.
// We have made the intentional choice to use these colors instead of the default palette provided by the AVP chart library.
// FROM: next/packages/admin-center/src/admin-center-core/base-components/ChartBase/ChartBase.tsx
export const chartColorPalette = [
	token('color.chart.categorical.1'),
	token('color.chart.categorical.2'),
	token('color.chart.categorical.3'),
	token('color.chart.categorical.4'),
	token('color.chart.categorical.5'),
	token('color.chart.categorical.6'),
	token('color.chart.categorical.7'),
	token('color.chart.categorical.8'),
];
